export type HubspotConversations = {
  on: (event: string, callback: (payload?: unknown) => void) => void;
  off: (event: string, callback: (payload?: unknown) => void) => void;
  widget: {
    load: (opts?: { widgetOpen?: boolean }) => void;
    open: () => void;
    close: () => void;
    remove: () => void;
    refresh: () => void;
    status: () => { loaded: boolean; pending: boolean };
  };
};

export type HubspotWindow = Window & {
  hsConversationsSettings?: { loadImmediately?: boolean };
  hsConversationsOnReady?: Array<() => void>;
  HubSpotConversations?: HubspotConversations;
};

export const getHubspotWindow = () => window as HubspotWindow;
